export const REQUEST_ACTIVITY_QUESTIONS = "REQUEST_ACTIVITY_QUESTIONS";
export const REQUEST_EXISTING_ACTIVITY_QUESTIONS = "REQUEST_EXISTING_ACTIVITY_QUESTIONS";
export const REQUEST_ACTIVITY_QUESTIONS_SUCCESS = "REQUEST_ACTIVITY_QUESTIONS_SUCCESS";
export const REQUEST_EXISTING_ACTIVITY_QUESTIONS_SUCCESS = "REQUEST_EXISTING_ACTIVITY_QUESTIONS_SUCCESS";
export const REQUEST_ACTIVITY_QUESTIONS_ERROR = "REQUEST_ACTIVITY_QUESTIONS_ERROR";
export const ANSWER_ACTIVITY_QUESTION = "ANSWER_ACTIVITY_QUESTION";

export const requestActivityQuestions = (activityId, followUpUUID) => {
    return {
        type: REQUEST_ACTIVITY_QUESTIONS,
        payload: {
            activityId: activityId ?? 286,
            followUpUUID,
        },
    };
};
export const requestExistingActivityQuestions = (referenceTicketNumber, followUpUUID) => {
    return {
        type: REQUEST_EXISTING_ACTIVITY_QUESTIONS,
        payload: {
            referenceTicketNumber: referenceTicketNumber ?? "",
            followUpUUID,
        },
    };
};
export const requestExistingActivityQuestionsSuccess = (payload, followUpUUID, answers) => {
    return {
        type: REQUEST_EXISTING_ACTIVITY_QUESTIONS_SUCCESS,
        payload: { questions: payload.activityQuestions, followUpUUID, answers, apiResponse: payload },
    };
};

export const requestActivityQuestionsSuccess = (questions, followUpUUID) => {
    return {
        type: REQUEST_ACTIVITY_QUESTIONS_SUCCESS,
        payload: { questions, followUpUUID },
    };
};

export const requestActivityQuestionsError = (error, followUpUUID) => {
    return {
        type: REQUEST_ACTIVITY_QUESTIONS_ERROR,
        payload: { error, followUpUUID },
    };
};
export const answerActivityQuestion = (value, formattedValue, questionId, followUpUUID, isAnswered) => {
    return {
        type: ANSWER_ACTIVITY_QUESTION,
        payload: {
            value,
            formattedValue,
            questionId,
            followUpUUID,
            isAnswered,
        },
    };
};
